import React from 'react'
import styled from 'styled-components'

import media from '../../../styles/media'

//Components
import Title from '../../step/title/title'
import Button from '../../step/button/button'

const ButtonWrapperCenter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
  ${media.md`
    margin-top: 40px;
`};
`

function StepThanks({ name, isOpen, toggleContact, currentStep }) {
  return 5 != currentStep ? null : (
    <div className="col-md-8 " style={{ margin: 'auto', textAlign: 'center' }}>
      <div className="col-md-6" style={{ margin: 'auto' }}>
        <Title title="Gracias pronto estaremos en contacto contigo." />
      </div>
      <ButtonWrapperCenter>
        <Button onClick={() => toggleContact(!isOpen)} title="Aceptar" />
      </ButtonWrapperCenter>
    </div>
  )
}

export default StepThanks



// WEBPACK FOOTER //
// ./src/components/contactus/steps/StepThanks.js